/**
 * «Юниверситет» (28.09): карточка «Вопросы дня». Набор на день выбирает сервер (дата
 * UTC+5, одинаково для всех), ответ даётся один раз, +daily.xp за каждый верный.
 * Точки красим: зелёная — верно, красная — нет (в макете красились все отвеченные).
 */
import { questionsWord } from "./ctx";
import css from "./uni.module.css";

interface DailyCardProps {
  ids: string[];
  answers: Record<string, 0 | 1>;
  xpPer: number;
  onStart: () => void;
}

export function DailyCard({ ids, answers, xpPer, onStart }: DailyCardProps) {
  const answered = ids.filter((id) => answers[id] !== undefined).length;
  const all = ids.length > 0 && answered >= ids.length;
  return (
    <section className={css.card} aria-labelledby="uni-daily-h" data-fb="daily-card" data-fb-name="Вопросы дня">
      <h3 className={css.h} id="uni-daily-h">
        Вопросы дня <b>{answered} / {ids.length}</b>
      </h3>
      <div className={css.daily}>
        <div className={css.dots} aria-hidden="true">
          {ids.map((id) => (
            <i key={id} className={answers[id] === 1 ? css.dotOk : answers[id] === 0 ? css.dotBad : ""} />
          ))}
        </div>
        <p>
          {!ids.length
            ? "Сегодня вопросов нет."
            : all
              ? "На сегодня всё. Завтра будут новые."
              : `${questionsWord(ids.length)}, +${xpPer} XP за каждый`}
        </p>
        <button type="button" className={css.btn} disabled={!ids.length || all} onClick={onStart}>
          {answered ? "Дальше" : "Начать"}
        </button>
      </div>
    </section>
  );
}
